import { Text } from 'platform-components';
import React from 'react';

import SvgExclamation from 'common.components/icon/__exclamation/icon__exclamation';
import { ProblemInCourse } from 'store/problems/typings';

import './lab-problem__usage.scss';

interface OwnProps {
    problem: ProblemInCourse;
}

interface Props extends OwnProps {}

export class ProblemUsage extends React.Component<Props> {
    render() {
        const { problem } = this.props;

        const numberUsageCardInCourse = problem?.inCourse?.length || 0;

        if (!numberUsageCardInCourse) {
            return null;
        }

        return (
            <div className="lab-problem__problem-usage">
                <SvgExclamation className="lab-problem__exclamation-icon" />
                <Text id="stack.countUsageInfo" values={{ number: numberUsageCardInCourse }} />
            </div>
        );
    }
}

export default ProblemUsage;
